<template>
  <div class="splide__slide">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Slide',
  mounted() {
    this.$emit('mounted');
  },
};
</script>

<style lang="scss" scoped>
.splide__slide {
  @apply mx-auto mb-4 shadow-lg;
  border-radius: 10px;
  overflow: hidden;
  & > * {
    height: inherit;
  }
}
</style>
